import React, { useState } from 'react';
import {
    QuickPickSportType,
    QuickPickView,
} from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView';
import { TrapChallenge } from 'src/components/CustomersBar/EventsTab/RacingTab/TrapChallengeView/TrapChallengeView';
import { AntePostListView } from './AntePostView/AntePostListView';
import { action, observable, makeAutoObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { SubviewsMenu, TelebetButton } from './RacingTab.style';

type RacingTabPropsType = {
    userId: number;
    sport: QuickPickSportType;
};

type MainViewType = 'quickPick' | 'antePost' | 'trapChallenge';

class RacingTabState {
    @observable public mainView: MainViewType = 'quickPick';

    public constructor() {
        makeAutoObservable(this);
    }

    @action public setView = (view: MainViewType): void => {
        this.mainView = view;
    };

    @action public setQuickPickView = (): void => {
        this.setView('quickPick');
    };

    @action public setAntePostView = (): void => {
        this.setView('antePost');
    };

    @action public setTrapChallenge = (): void => {
        this.setView('trapChallenge');
    };
}

export const RacingTab = observer('RacingTab', (props: RacingTabPropsType) => {
    const [state] = useState(() => new RacingTabState());

    const subViewsMenu = () => {
        return (
            <SubviewsMenu>
                {state.mainView !== 'quickPick' ? (
                    <li
                        className={state.mainView}
                        key={state.mainView}
                    >
                        <TelebetButton onClick={state.setQuickPickView}>Today</TelebetButton>
                    </li>
                ) : (
                    <>
                        <li
                            className={state.mainView}
                            key={state.mainView}
                        >
                            <TelebetButton onClick={state.setAntePostView}>Ante-Post</TelebetButton>
                        </li>
                        {props.sport === 'greyhoundracing' ? (
                            <li
                                className={state.mainView}
                                key={state.mainView}
                            >
                                <TelebetButton onClick={state.setTrapChallenge}>Trap-Challenge</TelebetButton>
                            </li>
                        ) : null}
                    </>
                )}
            </SubviewsMenu>
        );
    };

    const content = () => {
        switch (state.mainView) {
            case 'quickPick':
                return (
                    <QuickPickView
                        userId={props.userId}
                        sport={props.sport}
                    />
                );
            case 'antePost':
                return (
                    <AntePostListView
                        sport={props.sport}
                        userId={props.userId}
                    />
                );
            case 'trapChallenge':
                return <TrapChallenge userId={props.userId} />;
        }
    };

    return (
        <div className='events-tab--horse-racing'>
            {subViewsMenu()}
            {content()}
        </div>
    );
});
